import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles, Typography, Grid, Paper } from '@material-ui/core'
import format from 'date-fns/format'
import { getBookingState } from '../../store/booking/selectors'

const styles = theme => ({
  root: {
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2
  },
  serviceList: {
    margin: 0,
    paddingLeft: theme.spacing.unit * 3
  },
  extraDescription: {
    color: 'rgba(0, 0, 0, 0.54)'
  }
})

export class BookingPreviewBase extends Component {
  render() {
    const { classes, booking, showDate } = this.props

    return (
      <Paper>
        <Grid container className={classes.root}>
          <Grid item xs={12} sm={6}>
            <Typography color="inherit" variant="h6">
              Servizi prenotati
            </Typography>
            <ul className={classes.serviceList}>
              {booking.services.map(service => (
                <li key={service.id}>
                  <Typography color="inherit">{service.descrizione} {service.descrizioneAggiuntiva && <span className={classes.extraDescription}> - {service.descrizioneAggiuntiva}</span>}</Typography>
                </li>
              ))}
            </ul>
          </Grid>
          {showDate && (
            <Grid item xs={12} sm={6}>
              <Typography color="inherit" variant="h6">
                Giorno ed ora
              </Typography>
              <Typography color="inherit">
                <b>Giorno:</b> {format(booking.selectedDay, 'DD-MM-YYYY')}
              </Typography>
              <Typography color="inherit">
                <b>Ora:</b> {booking.selectedHour.descrizione}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Paper>
    )
  }
}

export const BookingPreview = withStyles(styles)(BookingPreviewBase)

const mapStateToProps = state => ({
  booking: getBookingState(state)
})

export const LinkedBookingPreview = connect(mapStateToProps)(BookingPreview)
